module.exports = __webpack_public_path__ + "static/media/02300014-QuB0wSgs.bdf03f98.JPG";